module.exports = __webpack_public_path__ + "img/it.e411485b.svg";